import { render, staticRenderFns } from "./CaseSettings.vue?vue&type=template&id=4d3a8880&scoped=true"
import script from "./CaseSettings.vue?vue&type=script&lang=js"
export * from "./CaseSettings.vue?vue&type=script&lang=js"
import style0 from "./CaseSettings.vue?vue&type=style&index=0&id=4d3a8880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a8880",
  null
  
)

export default component.exports